import { useCallback } from "react";
import { useToast, ToastId } from "@chakra-ui/react";
import { useGlobalState } from "modules/providers/global-state-provider";

interface ToastRenderProps {
  id?: ToastId;
  onClose: () => void;
}

const useDisplayToast = () => {
  const toast = useToast();

  const { toastId, setToastId } = useGlobalState();

  const displayToast = useCallback(
    (render?: (props: ToastRenderProps) => React.ReactNode) => {
      if (toastId && toast.isActive(toastId)) {
        toast.close(toastId);
      }
      setToastId(
        toast({
          position: "bottom",
          render,
          duration: 3000,
        }),
      );
    },
    [setToastId, toast, toastId],
  );

  return {
    displayToast,
  };
};

export default useDisplayToast;
